import AssetDocuments from "../document/AssetDocuments";

export default function VehicleSetupDocuments({ setupId}) {
  return <AssetDocuments ownerType={"SETUP"} ownerId={setupId} />;
}
